import React from 'react';
import { Page } from 'V2/Shared/SplashPageAssets';
import { Logo } from 'V2/Shared/Logo';
import { Video } from 'V2/Shared/Video';
import { AnimationPhrases } from './AnimationPhrases';
import { InfoCard } from './InfoCard';
import carDrivingMP4 from '../media/car-driving.mp4';
import carDrivingPNG from '../media/car-driving.png';
import styles from '../styles.module.css';
import cx from 'classnames';

type VehicleLoaderProps = {
  phrases: string[];
  infoCardTitle?: string;
  infoCardDescription?: string;
  hideLogo?: boolean;
  noSpaceAround?: boolean;
};

export const VehicleLoader = ({
  phrases,
  infoCardTitle,
  infoCardDescription,
  hideLogo,
  noSpaceAround,
}: VehicleLoaderProps) => {
  return (
    <Page>
      <div
        className={cx(styles.content, {
          [styles.noSpaceAround]: noSpaceAround,
        })}
      >
        {!hideLogo && <Logo />}
        <AnimationPhrases phrases={phrases} />
        <Video
          loop
          muted
          autoPlay
          playsInline
          width="100%"
          height="100%"
          className={styles.video}
          fallbackImageSrc={carDrivingPNG}
          videoSrc={{ mp4: carDrivingMP4 }}
        />
        <InfoCard title={infoCardTitle} description={infoCardDescription} />
      </div>
    </Page>
  );
};
